const ITEMS = [
  "THE HYBRID FITNESS RACE",
  "5.6 KM RUN",
  "7 FUNCTIONAL STATIONS",
  "ONE ARENA",
  "DELHI, INDIA",
];

export default function Marquee() {
  return (
    <div
      className="marquee relative border-b border-[#2e2e2a] py-6 lg:py-8 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center">
                <span
                  className={`font-display font-extrabold uppercase text-3xl md:text-5xl lg:text-6xl px-6 lg:px-10 whitespace-nowrap ${
                    i % 2 ? "text-stroke" : "text-[#ff5a1f]"
                  }`}
                >
                  {item}
                </span>
                <span className="font-mono text-[#6e6e6a] text-lg" aria-hidden="true">
                  //
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
